export function Data() {
  return (
    <h1>Data</h1>
  )
}